const doc = [({"ko":({"adminConstantPromotionApplicableConditionType":({"hotel":"모두", "hotelPlan":"플랜 지정", "hotelPlanAndHotelRoom":"플랜&룸 타입 지정", "hotelRoom":"방 타입 지정"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;